import React from "react";

const OpenBet = ({ info }) => {
  return (
    <div
      className="ml-2"
      style={{
        borderBottomStyle: "dotted",
        borderBottom: "1px dotted #006699",
      }}
    >
      <div
        className="mb-2 mt-2"
        style={{
          color: "#006699",
          fontFamily: "Calibri",
        }}
      >
        Racing ticket: <span style={{ color: "#586674" }}>{info.TicketID}</span>{" "}
        <br />
        RAC:{" "}
        <span style={{ color: "#586674" }}>
          {info.Description} {info.Selections}
        </span>
        <br />
        Stake: <span style={{ color: "#586674" }}>$ {info.TotalStake}</span>
      </div>
    </div>
  );
};

export default OpenBet;
